import React, { useEffect, useState } from 'react';
import { ModalProps } from '@features/Modal';
import './TradeOrderModal.scss';
import { Autocomplete, Box, Button, InputAdornment, MenuItem, TextField } from '@mui/material';
import { createTradeOrder, getSecuritiesAll } from '@pages/Preferences/api';
import { ReactComponent as TradeOrder } from '../../../../shared/assets/svgs/TradeOrder.svg';
import { useNotify } from '@features/Notify';
import { Loader } from '@shared/UI';

export const TradeOrderModal: React.FC<ModalProps> = (props) => {
    const [securities, setSecurities] = useState<any[]>();
    const [selectedItem, setSelectedItem] = useState<any | null>(null);
    const [action, setAction] = useState<string>(''); // NEW — for Buy/Sell
    const [percentage, setPercentage] = useState<number | string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [searchText, setSearchText] = useState('');
    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');
    const [isSharing, setIsSharing] = useState(false);
    const notify = useNotify();

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (searchText.length >= 2) {
                getSecuritiesAsync(searchText);
            }
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [searchText]);

    const getSecuritiesAsync = async (search: string) => {
        try {
            let req = await getSecuritiesAll(search);
            setSecurities(req);
        } catch (error) {}
    };

    useEffect(() => {
        getSecuritiesAsync('');
    }, []);

    const handleShareClick = async () => {
        if (selectedItem && percentage && action) {
            setIsSharing(true);
            try {
                var result = await createTradeOrder({
                    SecurityId: selectedItem?.id,
                    totalAmount: percentage,
                    RiaId: userObject?.id,
                    TradeOrderStatus: 'Pending',
                    Action: action, // NEW — send Buy/Sell
                });
                notify.success(result);
            } catch (error) {
                notify.error('Error creating trade order.');
            } finally {
                setSelectedItem(null);
                setAction('');
                setPercentage('');
                setIsSharing(false);
            }
        } else {
            setErrorMessage('Please select security, action, and amount.');
        }
    };

    if (isSharing) {
        return <Loader />;
    }

    return (
        <div className='widget-trade-table-modal'>
            <div className='widget-trade-table-modal__header'>
                <TradeOrder />
                <div>
                    <div className='widget-trade-table-modal__title'>Place order to trade desk</div>
                </div>
            </div>

            <div className='widget-trade-table-modal__content'>
                <Box
                    display='flex'
                    flexDirection='column'
                    gap={2}
                >
                    {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

                    <div className='flex-only'>
                        {/* Select Security */}
                        <div>
                            <div className='choose-list-header-trade'>Select Security</div>
                            <div className='security-percentage-div'>
                                <Autocomplete
                                    options={securities || []}
                                    value={selectedItem}
                                    onChange={(event, newValue) => setSelectedItem(newValue)}
                                    inputValue={searchText}
                                    onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                                    getOptionLabel={(option) => option?.symbol || ''}
                                    isOptionEqualToValue={(option, value) => option.symbol === value.symbol}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Select a Security'
                                            variant='outlined'
                                            fullWidth
                                        />
                                    )}
                                    disableClearable
                                    className='dropdown-security-percentage-div'
                                />
                            </div>
                        </div>

                        {/* Action */}
                        <div>
                            <div className='choose-list-header-trade'>Action</div>
                            <div className='security-percentage-div'>
                                <TextField
                                    select
                                    label='Buy/Sell'
                                    value={action}
                                    onChange={(e) => setAction(e.target.value)}
                                    variant='outlined'
                                    fullWidth
                                    className='dropdown-security-percentage-div'
                                >
                                    <MenuItem value='Buy'>Buy</MenuItem>
                                    <MenuItem value='Sell'>Sell</MenuItem>
                                </TextField>
                            </div>
                        </div>

                        {/* Amount */}
                        <div>
                            <div className='choose-list-header-trade'>Add Amount</div>
                            <TextField
                                fullWidth
                                type='number'
                                value={percentage}
                                onChange={(e) => setPercentage(e.target.value)}
                                placeholder='Enter amount here'
                                variant='outlined'
                                className='input-profit'
                                margin='normal'
                                InputProps={{
                                    startAdornment: <InputAdornment position='start'>$</InputAdornment>,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&:after': {
                                            borderRight: '2px solid #ccc',
                                        },
                                        '.MuiInputBase-inputAdornedStart': {
                                            padding: '9.5px 14px',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        borderLeft: '1px solid #ccc',
                                        background: 'white',
                                        paddingLeft: '10px',
                                    },
                                }}
                            />
                        </div>
                    </div>

                    {/* Save Button */}
                    <Button
                        variant='contained'
                        onClick={handleShareClick}
                        className='security-update-button'
                        disabled={isSharing || !percentage || !selectedItem || !action}
                    >
                        Save
                    </Button>
                </Box>
            </div>
        </div>
    );
};
